import { BatchPreviewAssignPage } from "../batch-preview-assign-page";
import { BatchPreviewTable } from "../batch-preview-table";

import { useBatchPreviewProjectAssignPage } from "./batch-preview-project-assign-page.hook";

export const BatchPreviewProjectAssignPage = () => {
  const { projects, loading, columns } = useBatchPreviewProjectAssignPage();

  return (
    <BatchPreviewAssignPage model="project">
      <BatchPreviewTable
        model="project"
        items={projects}
        loading={loading}
        columns={columns}
      />
    </BatchPreviewAssignPage>
  );
};
